<section class="component-container">
  <div class="page-header">
    <h3 class="page-title">Legal</h3>
  </div>

  <div class="policies-list">
    @for (policy of policies; track policy.id) {
      <div class="policy-row">
        <div class="policy-info">
          <h4 class="policy-title">{{ policy.title }}</h4>
        </div>
        <button class="open-policy-btn" (click)="openPolicy(policy.url)" title="Open in new tab">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <polyline points="15 3 21 3 21 9"></polyline>
            <line x1="10" y1="14" x2="21" y2="3"></line>
          </svg>
          <span>View</span>
        </button>
      </div>
    }
  </div>
</section>
